import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserDetectorService {
  isChrome: boolean;
  isEdge: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  isBrave: boolean;
  isOther: boolean;

  constructor() {
    const agent = window.navigator.userAgent.toLowerCase();

    this.isChrome = agent.indexOf('chrome') > -1;
    this.isEdge = agent.indexOf('edge') > -1;
    this.isFirefox = agent.indexOf('firefox') > -1;
    this.isSafari = agent.indexOf('safari') > -1;

    const isCommon = [
      this.isChrome,
      this.isEdge,
      this.isFirefox,
      this.isSafari,
    ];

    this.isBrave = !!(navigator as any)?.brave?.isBrave();

    this.isOther = [...isCommon, this.isBrave].every((val) => val === false);
  }
}
